import { store } from "../store/store";

export const getCurrentUserState = () => {
    return store.getState()?.user || {};
};

export const getCurrentUserId = () => {
    return getCurrentUserState().userId || null;
};

export const getCurrentUserName = () => {
    return getCurrentUserState().name || null;
};

export const getCurrentUserPhoto = () => {
    return getCurrentUserState().profilePhotoUrl || null;
};
